import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { SearchComponent } from './search/search.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { DashboardMyOasisComponent } from './dashboard-my-oasis/dashboard-my-oasis.component';
import { DashboardMarketsComponent } from './dashboard-markets/dashboard-markets.component';
import { DashboardOrdersComponent } from './dashboard-orders/dashboard-orders.component';
import { DashboardReportsComponent } from './dashboard-reports/dashboard-reports.component';
import { ApprovalsComponent } from './approvals/approvals.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { TasksComponent } from './tasks/tasks.component';
import { ManagementComponent } from './management/management.component';
import { DashboardMyOasisDetailComponent } from './dashboard-my-oasis/dashboard-my-oasis-detail/dashboard-my-oasis-detail.component';
import { LoginComponent } from './login/login.component';
import { AuthGuardService } from './services/auth-guard.service';
import { AdminGuardService } from './services/admin-guard.service';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthShellComponent } from './auth-shell/auth-shell.component';
import { OrderConfirmationComponent } from './order-confirmation/order-confirmation.component';
import { OrderApprovalComponent } from './order-approval/order-approval.component';
import { ApproveOrderComponent } from './approve-order/approve-order.component';
import { OrderWorksheetComponent } from './order-worksheet/order-worksheet.component';
import { OrderCreateComponent } from './order-create/order-create.component';
import { BomListComponent } from './boms/bom-list/bom-list.component';
import { OrderHubComponent } from './dashboard-orders/order-hub/order-hub.component';
import { OrderListComponent } from './dashboard-orders/order-list/order-list.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ReadonlyWorksheetComponent } from './readonly-worksheet/readonly-worksheet.component';
import { WarrantyClaimComponent } from './warranty-claim/warranty-claim.component';
import { ProjectOrderSummaryComponent } from './dashboard-my-oasis/project-order-summary/project-order-summary.component';
import { FullPageWrapperComponent } from './full-page-wrapper/full-page-wrapper.component';
import { OrderDetailViewComponent } from './order-detail-view/order-detail-view.component';
import { MarketOrderSummaryComponent } from './dashboard-my-oasis/market-order-summary/market-order-summary.component';
import { OrderActivityLogComponent } from './order-activity-log/order-activity-log.component';
import { DashboardTiledMyOasisComponent } from './dashboard-my-oasis/dashboard-tiled-my-oasis/dashboard-tiled-my-oasis.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { ProductAdvisoriesComponent } from './product-advisories/product-advisories.component';
import { RogReportImagesComponent } from './rog-report-images/rog-report-images.component';
import { OrderStatusReportComponent } from './dashboard-reports/orderstatus-report/orderstatus-report.component';
import { WorksheetStatusReportComponent } from './dashboard-reports/worksheetstatus-report/worksheetstatus-report.component';
import { TaskStatusReportComponent } from './dashboard-reports/taskstatus-report/taskstatus-report.component';
import { EnhancementFeedbackComponent } from './enhancement-feedback/enhancement-feedback.component';

const appRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'rog-report-images',
    component: RogReportImagesComponent,
  },
  {
    path: '',
    component: AuthShellComponent,
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: '/dashboard/(dashboard-content:my-oasis)',

          },
          { path: 'warranty-claim/:id', component: WarrantyClaimComponent, outlet: 'dashboard-content' },
          { path: 'my-oasis', component: DashboardMyOasisComponent, outlet: 'dashboard-content' },
          { path: 'my-oasis-tiled', component: DashboardTiledMyOasisComponent, outlet: 'dashboard-content' },
          { path: 'my-oasis-details/:id', component: DashboardMyOasisDetailComponent, outlet: 'dashboard-content' },
          { path: 'project-order-summary/:id/:target', component: ProjectOrderSummaryComponent, outlet: 'dashboard-content' },
	        { path: 'market-order-summary/:id', component: MarketOrderSummaryComponent, outlet: 'dashboard-content' },
          { path: 'markets', component: DashboardMarketsComponent, outlet: 'dashboard-content' },
          { path: 'reports', component: DashboardReportsComponent, outlet: 'dashboard-content' },
          { path: 'order-activity-log/:id', component: OrderActivityLogComponent, outlet: 'dashboard-content' },

          { path: 'order-create', component: OrderCreateComponent, outlet: 'dashboard-content' },
          { path: 'order-confirmation/:projectName/:accountNumber/:orderNumber', component: OrderConfirmationComponent, outlet: 'dashboard-content' },
          { path: 'approve-order', component: ApproveOrderComponent, outlet: 'dashboard-content' },
          { path: 'order-worksheet/:id', component: OrderWorksheetComponent, outlet: 'dashboard-content' },
          { path: 'order-approval', component: OrderApprovalComponent, outlet: 'dashboard-content' },
          { path: 'readonly-worksheet/:id', component: ReadonlyWorksheetComponent, outlet: 'dashboard-content' },
          {
            path: 'orders',
            component: DashboardOrdersComponent,
            outlet: 'dashboard-content',
            children: [
              {
                path: '',
                redirectTo: '/dashboard/(dashboard-content:orders/(order-content:order-hub))',
                pathMatch: 'full'
              },
              { path: 'order-hub', component: OrderHubComponent, outlet: 'order-content' },
              { path: 'order-list', component: OrderListComponent, outlet: 'order-content' },
            ]
          },
        ]
      },
      // {
      //   path: 'approvals',
      //   component: ApprovalsComponent
      // },
      {
        path: 'boms',
        component: BomListComponent
      },
      {
        path: '',
        redirectTo: '/dashboard/(dashboard-content:my-oasis)',
        pathMatch: 'full'
      },
      // {
      //   path: 'notifications',
      //   component: NotificationsComponent,
      // },
      {
        path: 'tasks',
        component: TasksComponent,
      },
      {
        path: 'profile',
        component: ProfileComponent,
      },
      {
        path: 'product-details/:sku/:accountNumber',
        component: ProductDetailComponent,
      },
      {
        path: 'search',
        component: SearchComponent,
      },
      {
        path: 'management',
        component: ManagementComponent,
        canActivate: [AdminGuardService]
      },
      {
        path: 'reports',
        component: DashboardReportsComponent,
        canActivate: [AdminGuardService],
      },
      {
        path: 'quote-process',
        component: FullPageWrapperComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: '/quote-process',

          },
          {
            path: 'checkout/:id',
            component: CheckoutComponent,
            outlet: 'quote-process-content'
          },
          {
            path: 'product-advisories/:id',
            component: ProductAdvisoriesComponent,
            outlet: 'quote-process-content'
          },
          {
            path: 'confirmedOrder/:id',
            component: OrderDetailViewComponent,
            outlet: 'quote-process-content'
          }

        ]
      },
      {
        path:'orderstatusreport',
        component: OrderStatusReportComponent,
        canActivate: [AuthGuardService]
      },
      {
        path:'worksheetstatusreport',
        component: WorksheetStatusReportComponent,
        canActivate: [AuthGuardService]
      },
      {
        path:'taskstatusreport',
        component: TaskStatusReportComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'enhancement',
        component: EnhancementFeedbackComponent
      }

    ]
  },
  {
    path: '',
    redirectTo: '/dashboard/(dashboard-content:my-oasis)',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { enableTracing: false })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/routing.module.ts